import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const BlackCont = styled('div')(({ theme }) => ({
  background: '#0d1117',
  border: `1px solid ${COLORS.PRIMARY}`,
  borderRadius: 8,
  padding: '20px 80px 40px',
  minWidth: 390,
  width: '70%',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: 20,
  },
}));
